import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ManagerJourneyFragment = { id: string, name: string, status: Types.JourneyStatusEnum, userCount: number, iconSettings?: { iconColor?: string | null, type: Types.IconTypeEnum, value: string } | null, createdBy?: { id: string, name?: string | null } | null, participantsProfiles?: Array<{ name?: string | null, id: string, profilePicture?: string | null }> | null };


export type ManagerJourneyFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export type GetJourneysQueryVariables = Types.Exact<{
  filters?: Types.InputMaybe<Types.JourneyFilters>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.SortType>> | Types.InputMaybe<Types.SortType>>;
}>;


export type GetJourneysQuery = { journeys?: { errorCode?: Types.PaginationErrorCodeEnum | null, success: boolean, totalCount: number, edges?: Array<{ node: { id: string, name: string, status: Types.JourneyStatusEnum, userCount: number, iconSettings?: { iconColor?: string | null, type: Types.IconTypeEnum, value: string } | null, createdBy?: { id: string, name?: string | null } | null, participantsProfiles?: Array<{ name?: string | null, id: string, profilePicture?: string | null }> | null } }> | null, pageInfo?: { endCursor?: string | null, hasNextPage?: boolean | null } | null } | null };

export const ManagerJourneyFragmentDoc = /*#__PURE__*/ gql`
    fragment ManagerJourney on JourneyType {
  id
  name
  iconSettings {
    iconColor
    type
    value
  }
  status
  createdBy {
    id
    name
  }
  participantsProfiles {
    name
    id
    profilePicture
  }
  userCount
}
    `;
export const GetJourneysDocument = /*#__PURE__*/ gql`
    query getJourneys($filters: JourneyFilters, $first: Float, $after: String, $sort: [SortType]) {
  journeys(filters: $filters, first: $first, after: $after, sort: $sort) {
    edges {
      node {
        ...ManagerJourney
      }
    }
    errorCode
    pageInfo {
      endCursor
      hasNextPage
    }
    success
    totalCount
  }
}
    ${ManagerJourneyFragmentDoc}`;

export function useGetJourneysQuery(options?: Omit<Urql.UseQueryArgs<GetJourneysQueryVariables>, 'query'>) {
  return Urql.useQuery<GetJourneysQuery, GetJourneysQueryVariables>({ query: GetJourneysDocument, ...options });
};